import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=5ebd5844&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"
import style0 from "./Sales.vue?vue&type=style&index=0&id=5ebd5844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebd5844",
  null
  
)

export default component.exports